export default __webpack_public_path__ + "static/media/intro3.fa02e8fb.png";